import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Container } from "../layout/Container";
import { StatCard } from "./StatCard";

export interface HeroSectionProps {
  onOpenInquiry?: () => void;
}

const STAT_KEYS: { value: string; key: string }[] = [
  { value: "15+", key: "stats.years" },
  { value: "200+", key: "stats.clients" },
  { value: "100%", key: "stats.professionalism" },
  { value: "365", key: "stats.support" },
];

export function HeroSection({
  onOpenInquiry,
}: HeroSectionProps): React.ReactElement {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-[120px]">
      <Container className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
        <div className="flex-1 flex flex-col gap-6 lg:gap-12 max-w-full">
          <div className="flex flex-col gap-6">
            <h1 className="text-navy text-4xl md:text-5xl lg:text-[64px] font-bold leading-tight tracking-tight">
              {t("hero.title")}
            </h1>
            <p className="text-gold text-2xl md:text-3xl font-medium tracking-tight">
              {t("hero.subtitle")}
            </p>
            <p className="text-gray-body text-lg md:text-xl leading-snug max-w-full">
              <Trans i18nKey="hero.description" components={{ bold: <strong /> }} />
            </p>
          </div>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/services"
              className="inline-flex items-center justify-center px-4 py-3 bg-navy text-white text-lg font-medium rounded-xl shadow hover:opacity-90 transition-opacity"
            >
              {t("hero.ctaServices")}
            </Link>
            <button
              type="button"
              onClick={onOpenInquiry}
              className="inline-flex items-center justify-center px-4 py-3 border-2 border-navy text-navy text-lg font-medium rounded-xl shadow-sm hover:bg-navy/5 transition-colors"
            >
              {t("hero.ctaInquiry")}
            </button>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-6 lg:gap-[74px] w-full lg:w-auto">
          {STAT_KEYS.map(({ value, key }) => (
            <StatCard key={key} value={value} label={t(key)} />
          ))}
        </div>
      </Container>
    </section>
  );
}

export default HeroSection;
